import { render, staticRenderFns } from "./customerScore.vue?vue&type=template&id=5d9d68b3&scoped=true&"
import script from "./customerScore.vue?vue&type=script&lang=js&"
export * from "./customerScore.vue?vue&type=script&lang=js&"
import style0 from "./customerScore.vue?vue&type=style&index=0&id=5d9d68b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d68b3",
  null
  
)

export default component.exports